import HeaderBar from "@/components/Header";
import { useStore } from "vuex";
import chatSliderbar from "@/components/AiChat/chat-sliderbar";
import { useRoute } from "vue-router";
import { onMounted, ref, watch, computed, onBeforeMount, watchEffect } from "vue";
import useAccess from "@/hooks/useAccess";
import copyToClipboard from "copy-to-clipboard";
import { ElMessage } from "element-plus";
import aiDialog from "@/components/AiDialog";
import VipDialog from "@/components/vipDialog";
export default {
  components: {
    aiDialog,
    HeaderBar,
    chatSliderbar,
    VipDialog
  },
  setup() {
    window._copyToClipboard = function (target) {
      copyToClipboard(target.parentElement.nextElementSibling.innerText);
      ElMessage.success("已复制到剪切板");
    };
    const store = useStore();
    const route = useRoute();
    const showLogin = ref(false);
    const showLogin_ = computed(() => {
      return store.state.showLogin;
    });
    watch(showLogin_, v => {
      if (v) {
        if (isWechat) {
          return weChatLogin();
        } else {
          showLogin.value = true;
        }
      }
    });
    watch(showLogin, v => {
      if (!v) store.commit("SET_SHOW_LOGIN", false);
    });
    const showUserInfo = ref(false);
    const showUserInfo_ = computed(() => {
      return store.state.showUserInfo;
    });
    watch(showUserInfo_, v => {
      if (v) {
        store.dispatch("getUserInfo");
        showUserInfo.value = true;
      }
    });
    watch(showUserInfo, v => {
      if (!v) store.commit("SET_SHOW_USERINFO", false);
    });
    const showVip = ref(false);
    const showVip_ = computed(() => {
      return store.state.showVip;
    });
    watch(showVip_, v => {
      if (v) showVip.value = true;
    });
    watch(showVip, v => {
      if (!v) store.commit("SET_SHOW_VIP", false);
    });
    const {
      qrcodeImg,
      redirectToURL,
      doLoginProcess,
      stopCheckLoop,
      isWechat,
      isMobile,
      weChatLogin
    } = useAccess();
    const userInfo = computed(() => {
      return store.state.userInfo;
    });
    store.dispatch("getUserInfo");
    watch(showLogin, v => {
      if (v) {
        doLoginProcess();
      } else {
        stopCheckLoop();
      }
    });
    function redirectToURL_call() {
      console.log(redirectToURL.value);
      window.location.href = redirectToURL.value;
    }
    // 设置cookie
    function setCookie(name, value, seconds) {
      seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
      let expires = "";
      if (seconds !== 0) {
        //设置cookie生存时间
        const date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "; expires=" + date.toGMTString();
      }
      document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
    }

    function getHashUrlParam(name) {
      const hashParts = window.location.hash.split("?");
      if (hashParts.length < 2) {
        return null;
      }
      const hashQueries = new URLSearchParams(hashParts[1]);
      return hashQueries.get(name);
    }
    onMounted(() => {
      const tui_id = getHashUrlParam("tui_id");
      if (tui_id) {
        setCookie("tui_id", tui_id, 3 * 24 * 60 * 60);
      }
    });
    onMounted(() => {
      const tuid = getHashUrlParam("tuid");
      if (tuid) {
        setCookie("tuid", tuid, 3 * 24 * 60 * 60);
      }
    });
    onMounted(() => {
      const sitecode = getHashUrlParam("sitecode");
      if (sitecode) {
        setCookie("sitecode", sitecode, 3 * 24 * 60 * 60);
      }
    });
    onMounted(() => {
      const x_site = getHashUrlParam("x-site");
      if (x_site) {
        setCookie("x-site", x_site, 3 * 24 * 60 * 60);
      }
    });
    onMounted(() => {
      let timer = null;
      const docEl = document.documentElement,
        resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function () {
          clearTimeout(timer);
          timer = setTimeout(() => {
            if (docEl.clientWidth < 768) {
              store.commit("SET_CHAT_SLIDER", false);
              store.commit("SET_IS_MOBILE", true);
            } else {
              // 这部分才默认打开
              if (route.name === "chat") {
                store.commit("SET_CHAT_SLIDER", true);
              }
              store.commit("SET_IS_MOBILE", false);
            }
          }, 100);
        };
      recalc();
      if (!document.addEventListener) return;
      window.addEventListener(resizeEvt, recalc, false); //窗体大小发生改变时
      document.addEventListener("DOMContentLoaded", recalc, false); //文档重载时
    });

    return {
      route,
      showLogin,
      showVip,
      isMobile,
      isWechat,
      qrcodeImg,
      redirectToURL,
      redirectToURL_call,
      showUserInfo,
      userInfo,
      openVipDialog() {
        store.commit("SET_SHOW_VIP", true);
      }
    };
  }
};